import { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { NAMESPACE, PRIVATE_PATH } from '@/constants';
import { useGetMediaPlanQuery } from '@/api';
import { Content, PageSectionHeader } from '@/components';
import { RaiseIoPanel } from '@/pages/MediaPlanList/components/Actions/components/RaiseIoPanel';

/**
 * Raising an Insertion Order, as a page rather than an overlay.
 *
 * The document is reviewed alongside the form before sending, which needs the
 * full width of the screen — a drawer left the rendered IO in a narrow column.
 */
const RaiseIo: FC = () => {
  const { t } = useTranslation(NAMESPACE.MEDIA_PLAN_PAGE);
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  // The document is named after the campaign it belongs to, so an AM does not
  // have to retype it — and IOs stay consistently named across plans.
  const { data: mediaPlan } = useGetMediaPlanQuery(id as string, { skip: !id });
  const campaignName = mediaPlan?.campaign?.name;

  const back = () => navigate(PRIVATE_PATH.MEDIA_PLAN);

  return (
    <>
      <PageSectionHeader
        actions={
          <Button icon={<ArrowLeftOutlined />} onClick={back}>
            {t('back')}
          </Button>
        }
      >
        {t('raiseIo', { ns: NAMESPACE.COMMON })}
      </PageSectionHeader>
      <Content>{id && <RaiseIoPanel
          mediaPlanId={id}
          defaultName={campaignName ? `IO - ${campaignName}` : undefined}
          onDone={back}
          onCancel={back}
        />}</Content>
    </>
  );
};

export default RaiseIo;
